module.exports = __webpack_public_path__ + "img/IMG_7245.6f2693f2.jpg";